jQuery(document).ready(function($) {
    jQuery(".post-single-hero").each(function(index) {
        jQuery('.post-single-hero .social_share_btn').click(function() {
            jQuery(this).parent().addClass('active');
        });
        jQuery('.close_social_share_tab').click(function() {
            jQuery(this).parent().parent().parent().removeClass('active');
        });
    });

});